import script from "./EmailComposeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmailComposeModal.vue?vue&type=script&setup=true&lang=ts"

import "./EmailComposeModal.vue?vue&type=style&index=0&id=00a4ecf3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00a4ecf3"]])

export default __exports__